export class HistorialFuentes {
  id: number;
  idFte: number;
  idUsuarioModifica: number;
  observacion: string;
  accion: string;
  fecha: Date;
}
